import {Logement} from '../logement';
import {deserializeAs} from 'cerialize';

export class SynthesePostesConsommation {

  public static readonly CONSOMMATION_CHAUFFAGE_COLOR = '#ff6c59';
  public static readonly CONSOMMATION_ECS_COLOR = '#60bbff';
  public static readonly CONSOMMATION_REFROIDISSEMENT_COLOR = '#edc3f5';
  public static readonly CONSOMMATION_PRISES_ELEC_COLOR = '#4bc0c0';
  public static readonly CONSOMMATION_AUTRES_COLOR = '#f08c00';

  @deserializeAs(Date)
  from: Date;
  @deserializeAs(Date)
  to: Date;
  @deserializeAs(Logement)
  logement: Logement;

  @deserializeAs(Number, 'consommation_chauffage')
  consommationChauffage: number;
  @deserializeAs(Number, 'consommation_ecs')
  consommationEcs: number;
  @deserializeAs(Number, 'consommation_refroidissement')
  consommationRefroidissement: number;
  @deserializeAs(Number, 'consommation_prises_electrique')
  consommationPrisesElectrique: number;
  @deserializeAs(Number, 'consommation_autres')
  consommationAutres: number;
}
